
import {HTTPServer} from '@/common/js/ajax.js'
export default {
  data () {
    return {
      searchInput: '',
      disabled: true,
      tableList: [],
      moduleId: 6,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      statusData: {'0': '未使用', '1': '部分使用', '2': '已使用', '3': '已过期'},
      dialogDetail: false,
      inviteCodeDtl: {},
      tabType: 0,
      dialogAdd: false,
      number: '',
      err_n: '',
      quantity: '',
      err_q: '',
      endTime: '',
      err_et: '',
      remark: '',
      dialogDelete: false,
      pageSize2: 20,
      pageNum2: 1,
      tableTotal2: 0,
      userList: [],
      dialogCusDetail: false,
      customerData: {}
    }
  },
  mounted () {
    this.queryInviteList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    // 关闭详情窗口
    this.$bus.on('closeDetailModal', (value) => {
      if (value) {
        this.dialogCusDetail = false
      }
    })
    // 关闭试用详情窗口
    this.$bus.on('close-trial-detail', (value) => {
      if (value) {
        this.dialogCusDetail = false
      }
    })
    // 更新消费策略的客户列表 - 试用
    this.$bus.off('query-trial-list')
    this.$bus.on('query-trial-list', (value, page) => {
      if (value) {
        if (page) {
          this.pageNum2 = 1
        }
        this.queryFormalUserListByInviteId()
      }
    })
    // 更新消费策略的客户列表 - 正式
    this.$bus.off('query-formal-list')
    this.$bus.on('query-formal-list', (value, page) => {
      if (value) {
        if (page) {
          this.pageNum2 = 1
        }
        this.queryFormalUserListByInviteId()
      }
    })
  },
  methods: {
    /** 获取邀请码 */
    queryInviteList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryInviteList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryInviteList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryInviteList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryInviteList()
    },
    /** 新增邀请码弹窗 */
    AddDialog () {
      var date = new Date()
      this.dialogAdd = true
      this.number = 1
      this.err_n = ''
      this.quantity = 1
      this.err_q = ''
      this.endTime = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 00:00:00').getTime()
      this.err_et = ''
      this.remark = ''
    },
    /** 进入邀请码详情 */
    rowClick (row, event, column) {
      this.activeNames = ['1', '2', '3']
      this.inviteCodeDtl = row
      this.tabType = 0
      this.dialogDetail = true
    },
    /** 邀请码 - 保存（新增、编辑）
     * 24*60*60*1000-1000 23*60*60*1000+59*60*1000+59*1000 86399000
     */
    dialogSave () {
      var b = this.dataTraversal()
      if (b) {
        let jsondata = {'number': this.number, 'quantity': this.quantity, 'endTime': this.endTime + 86399000, 'remark': this.remark}
        console.log(jsondata)
        if (this.dialogDetail) {
          delete jsondata.number
          jsondata.id = this.inviteCodeDtl.id
          HTTPServer.editInvite(jsondata, 'Loading').then((res) => {
            this.$message({
              showClose: true,
              message: '保存成功！',
              type: 'success'
            })
            this.inviteCodeDtl.quantity = jsondata.quantity
            this.inviteCodeDtl.end_time = jsondata.endTime
            this.inviteCodeDtl.remark = jsondata.remark
            this.dialogAdd = false
            this.queryInviteList()
          })
        } else {
          HTTPServer.saveInvite(jsondata, 'Loading').then((res) => {
            this.$message({
              showClose: true,
              message: '保存成功！',
              type: 'success'
            })
            this.dialogAdd = false
            this.queryInviteList()
          })
        }
      }
    },
    /** 数据遍历 */
    dataTraversal () {
      let date = new Date()
      let time = new Date((date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 23:59:59').getTime()
      this.err_n = ''
      this.err_q = ''
      this.err_et = ''
      let reg = /^[1-9]\d*$/
      if (!this.number) {
        this.err_n = '个数不能为空'
        return false
      }
      if (!reg.test(this.number)) {
        this.err_n = '格式错误'
        return false
      }
      if (!this.quantity) {
        this.err_q = '使用次数不能为空'
        return false
      }
      if (!reg.test(this.quantity)) {
        this.err_q = '格式错误'
        return false
      }
      if (this.quantity < this.inviteCodeDtl.use_number && this.dialogDetail) {
        this.err_q = '允许试用次数不能小于已使用次数'
        return false
      }
      if (!this.endTime) {
        this.err_et = '有效期截止日期不能为空'
        return false
      }
      if (time > (this.endTime + 86399000) && !this.dialogDetail) {
        this.err_et = '有效期截止日期不能小于今天'
        return false
      }
      return true
    },
    /** 邀请码 - 删除 */
    userDelete () {
      let arr = []
      let err = false
      if (this.dialogDetail) {
        if (this.inviteCodeDtl.status === '1' || this.inviteCodeDtl.status === '2') err = true
        arr.push(this.inviteCodeDtl.id)
      } else {
        this.multipleSelection.map((item) => {
          if (item.status === '1' || item.status === '2') err = true
          arr.push(item.id)
        })
      }
      if (err) {
        this.$message({
          showClose: true,
          message: '只能删除已过期和未使用的邀请码',
          type: 'error'
        })
        return
      }
      HTTPServer.delInviteCode({id: arr.toString()}, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.dialogDetail = false
        this.dialogDelete = false
        this.pageNum = 1
        this.queryInviteList()
      })
    },
    /** 邀请码 - 编辑弹窗 */
    editDialog () {
      this.dialogAdd = true
      let data = JSON.parse(JSON.stringify(this.inviteCodeDtl))
      this.number = '1'
      this.err_n = ''
      this.quantity = data.quantity
      this.err_q = ''
      this.endTime = data.end_time
      this.err_et = ''
      this.remark = data.remark
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (cmd) {
      if (cmd === '1') {
        this.dialogDelete = true
      }
    },
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryFormalUserListByInviteId()
      } else if (type === 2) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.inviteCodeDtl.id})
      }
    },
    /** 邀请码 - 客户列表 */
    queryFormalUserListByInviteId () {
      var jsondata = {'pageNum': this.pageNum2, 'pageSize': this.pageSize2, 'invite_id': this.inviteCodeDtl.id}
      HTTPServer.queryFormalUserListByInviteId(jsondata, 'Loading').then((res) => {
        this.userList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal2 = pageInfo.totalRows
      })
    },
    /** 显示每页条数 */
    handleSizeChange2 (val) {
      this.pageSize2 = val
      this.pageNum2 = 1
      this.queryFormalUserListByInviteId()
    },
    /** 跳转第几页 */
    handleCurrentChange2 (val) {
      this.pageNum2 = val
      this.queryFormalUserListByInviteId()
    },
    /** 邀请码 - 客户列表 - 客户详情  */
    userRow (row, event, column) {
      this.customerData = row
      this.dialogCusDetail = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/controller/inviteCode.js